import product from "../../images/product3.jpg";


 
// Inagration

import i11 from "../../images/inagration/i11.jpg";
import i12 from "../../images/inagration/i12.jpg";
import i13 from "../../images/inagration/i13.jpg";
import i14 from "../../images/inagration/i14.jpg";
import i15 from "../../images/inagration/i15.jpg";
import i16 from "../../images/inagration/i16.jpg";
import i17 from "../../images/inagration/i17.jpg";
import i18 from "../../images/inagration/i18.jpg";
import i19 from "../../images/inagration/i19.jpg";
import i20 from "../../images/inagration/i20.jpg";
import i21 from "../../images/inagration/i21.jpg";


//events 
import e10 from "../../images/flashmob/e10.jpg";
import e11 from "../../images/flashmob/e11.jpg";
import e12 from "../../images/flashmob/e12.jpg";
import e13 from "../../images/flashmob/e13.jpg";

// Flashmob
import f1 from "../../images/flashmob/f1.jpg";
import f2 from "../../images/flashmob/f2.jpg";
import f3 from "../../images/flashmob/f3.jpg";
import f4 from "../../images/flashmob/f4.jpg";

// Culturals
import c1 from "../../images/culturals/c1.jpg";
import c11 from "../../images/culturals/c11.jpg";
import c12 from "../../images/culturals/c12.jpg";
import c13 from "../../images/culturals/c13.jpg";
import c15 from "../../images/culturals/c15.jpg";

// Workshops

import w6 from "../../images/workshops/w6.jpg";
import w11 from "../../images/workshops/w11.jpg";
import w12 from "../../images/workshops/w12.jpg";
import w13 from "../../images/workshops/w13.jpg";
import w14 from "../../images/workshops/w14.jpg";
import w15 from "../../images/workshops/w15.jpg";
import w16 from "../../images/workshops/w16.jpg";
import w17 from "../../images/workshops/w17.jpg";
import w18 from "../../images/workshops/w18.jpg";

export const ImagesJson = [
    
    { src: i11, title: "Inagration 1", route: "/2k24"},
    { src: i12, title: "Inagration 2", route: "/2k24"},
    { src: i13, title: "Inagration 3", route: "/2k24"},
    { src: i14, title: "Inagration 4", route: "/2k24"},
    { src: i15, title: "Inagration 5", route: "/2k24"},
    { src: i16, title: "Inagration 6", route: "/2k24"},
    { src: i17, title: "Inagration 7", route: "/2k24"},
    { src: i18, title: "Inagration 8", route: "/2k24"},
     { src: i19, title: "Inagration 9", route: "/2k24"},
      { src: i20, title: "Inagration 10", route: "/2k24"},
       { src: i21, title: "Inagration 11", route: "/2k24"},
    
    { src: w6, title: "Workshop 1", route: "/2k23" },
   
    { src: w11, title: "Workshop 2", route: "/2k24"},
    { src: w12, title: "Workshop 3", route: "/2k24"},
    { src: w13, title: "Workshop 4", route: "/2k24"},
    { src: w14, title: "Workshop 5", route: "/2k24"},
     { src: w15, title: "Workshop 6", route: "/2k24"},
     { src: w16, title: "Workshop 7", route: "/2k24"},
     { src: w17, title: "Workshop 8", route: "/2k24"},
     { src: w18, title: "Workshop 9", route: "/2k24"},
    
    
    { src: e10, title: "Event 1", route: "/2k24"},
    { src: e11, title: "Event 2", route: "/2k24"},
    { src: e12, title: "Event 3", route: "/2k24"},
    { src: e13, title: "Event 4", route: "/2k24"},

    { src: f1, title: "Flashmob 1", route: "/2k23" },
    { src: f2, title: "Flashmob 2", route: "/2k23" },
    { src: f3, title: "Flashmob 3", route: "/2k23" },
    { src: f4, title: "Flashmob 4", route: "/2k23" },
   { src: c1, title: "Cultural 1", route: "/2k24"},
    { src: c11, title: "Cultural 2", route: "/2k24"},
    { src: c12, title: "Cultural 3", route: "/2k24"},
    { src: c13, title: "Cultural 4", route: "/2k24"},
    { src: c15, title: "Cultural 5", route: "/2k24"},

];
